/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DismissibleAlert } from '../models/DismissibleAlert';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DismissibleAlertsService {
    /**
     * Get all dismissible alerts
     * @returns DismissibleAlert successful
     * @throws ApiError
     */
    public static getAllDismissibleAlerts(): CancelablePromise<Array<DismissibleAlert>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/dismissible_alerts.json',
        });
    }
    /**
     * Create or update dismissible alert
     * @param requestBody
     * @returns DismissibleAlert successful
     * @throws ApiError
     */
    public static createOrUpdateDismissibleAlert(
        requestBody?: {
            alertId: string;
            dismissed: boolean;
        },
    ): CancelablePromise<DismissibleAlert> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/dismissible_alerts.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
